import { ContentType } from "@treefort/api-spec"
import { PROGRESS_VERSION, PROGRESS_KEY_PREFIX } from "@treefort/constants"

export function getProgressItemKey({
  contentId,
  contentType,
  podcastEpisode,
}: {
  contentId: number
  contentType: ContentType
  podcastEpisode?: number
}) {
  const suffix = `${contentType}.${contentId}${
    contentType === "podcast" ? `.episode.${podcastEpisode || 1}` : ""
  }`
  return `${PROGRESS_KEY_PREFIX}.${PROGRESS_VERSION}.${suffix}`
}

/**
 * The base functionality that all progress items must implement
 */
export abstract class BaseProgressItem<
  Data extends { contentType: ContentType; contentId: number },
  Progress extends Record<string, unknown>,
> {
  private data: Data
  private profileId: string | null
  private key: string

  constructor({ data, profileId }: { data: Data; profileId: string | null }) {
    this.data = data
    this.profileId = profileId
    this.key = getProgressItemKey(this.data)
  }

  abstract getProgress: () => Progress

  abstract inProgress: () => boolean

  getKey = () => this.key

  getData = () => this.data

  getProfileId = () => this.profileId
}
